import { render, staticRenderFns } from "./userTemplateHeaderList.vue?vue&type=template&id=b35f543a&"
import script from "./userTemplateHeaderList.vue?vue&type=script&lang=js&"
export * from "./userTemplateHeaderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports